import { Component, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { apiService } from 'src/app/service/api.service';
import { ValidacionComponent } from '../../validacion.component';

@Component({
  selector: 'app-validacion-resumen',
  templateUrl: './resumen-validacion.component.html',
  styleUrls: ['./resumen-validacion.component.css']
})
export class ResumenValidacionComponent implements OnInit {

  resumenRegion = [];
  resumenPrograma = [];

  constructor(
    private api: apiService,    
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.getServerData(); 
  }

  public getServerData(){
    this.spinner.show();
    this.api.API_POST_getResumenValidacionRegion().subscribe((response: any) => {
      this.resumenRegion = response.payload;
      this.api.API_POST_getResumenValidacionPrograma().subscribe((response: any) => {
        this.resumenPrograma = response.payload;
        this.spinner.hide();   
      },
      (err) => {
        console.log("error"+err)
      })
        
    },
    (err) => {
      console.log("error"+err)
    })
  }
}


